// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../image/section.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo_header {
  width: 230px;
  object-fit: cover;
  object-position: center;
  margin: auto;
  justify-content: center;
  display: flex;
}
.phone16pro {
  width: 38%;
  object-fit: cover;
  object-position: center;
}
.payment-methods{
  display: flex;
}
.section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 70px;
  padding-bottom: 70px;
}

.product h1 {
  font-size: 64px;
  font-weight: 600;
  color: #fff;
}

.product p {
  font-size: 24px;
  font-weight: 600;
  margin-top: 30px;
  color: #fff;
}
#sections {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: 100px;
}

.mobile {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.mobile img {
  cursor: pointer;
  width: 100px;
  height: 30px;
  object-fit: contain;
  object-position: center;
}
.none{
    display: none;
}
.about h2 {
  color: #000;
  font-size: 36px;
  font-weight: 600;
}
.about h2 span {
  color: #117be2;
  font-size: 36px;
  font-weight: 600;
}
.about p {
  color: #504f4c;
  font-size: 24px;
  font-weight: 400px;
}
.about {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.features_grid {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.feature_card {
  margin-top: 40px;
  background: #03d5ed80;
  padding: 20px;
  border-radius: 32px;
  width: 24%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.feature_card {
  opacity: 0;
  transform: translateY(30px);
}


.cars {
  background-color: #117de280;
}
.feature_card h3 {
  margin-top: 12px;
  margin-bottom: 12px;
  color: #141416;
  font-size: 22px;
  font-weight: 600;
}

.feature_card p {
  font-size: 16px;
  font-weight: 400;
  color: #070707;
}

.icon {
  width: 50px;
  height: 50px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon img {
  width: 25px;
  height: 25px;
  object-fit: contain;
  object-position: center;
}
.about_app_container {
  display: flex;
  align-items: start;
  justify-content: space-between;
  background-color: #e5e5e5;
  padding-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
  border-radius: 32px;
  width: 90%;
  margin: 100px auto;
  overflow: hidden;
}

.about_image {
  flex: 0 1 300px;
  position: relative;
}
.about_text h2 {
  font-size: 35px;
  font-weight: 600;
}
.about_text p {
  margin-top: 24px;
  font-size: 18px;
  font-weight: 400;
  color: #1b1c20;
}
.about_text {
  width: 60%;
}

.about_image img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
  position: relative;
  object-position: center;
  z-index: 1;
  top: 4px;
  left: 10px;
  border-radius: 20px;
}

.about_image::before {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.food-image img {
  width: 60%;
  margin: auto;
  display: flex;
  justify-content: center;
}
.food-image {
  position: relative;
}
.sale {
  background-color: #fc6262;
  border-radius: 15px;
  width: 50px;
  text-align: center;
  margin-top: -8px;
  z-index: 99;
  position: absolute;
  margin-left: 10px;
}
.detail{
    margin-left: 10px;
    margin-top: 10px;
}
.red_food img{
    width: 106px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}
.red_foods img{
    width: 106px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}
.red_food{
    width: 107px;
    border-radius:10px;
    background-color: #F9FAFB;
    box-shadow: 0px 24px 48px -12px #1018282E;
    position: absolute;
    left: -33%;
    right: 0;
    margin: auto;
}
.red_foods{
    width: 107px;
    border-radius:10px;
    background-color: #F9FAFB;
    box-shadow: 0px 24px 48px -12px #1018282E;
    position: absolute;
    left: 30%;
    top: 30%;
    right: 0;
    margin: auto;
}
.sale p{
    color: #fff;
    font-size: 12px;
    font-weight: 400;
}
.red_food h6{
    font-size: 13px;
    font-weight: 600;
    color: #000;
}
.price{
    font-weight: 600;
    color: #CF2828;
    font-size: 13px;
}
.prices{
    display: flex;
    gap: 5px;
    margin-top: 7px;

    margin-bottom: 6px;
}
.strikethrough {
    color: #A0A0A0;
    font-weight: 400;
    font-size: 13px;
    text-decoration: line-through;
    text-align: center; 
    display: inline-block; 
}


.add{
    margin-bottom: 10px;
    margin-top: 8px;
}

.koled{
    background-color: #117be2;
    padding: 40px 100px 60px;
    border-radius: 32px;
    margin: -50px auto;
    position: relative;
    z-index: 9;
    width: 90%;
}


.bonus h1{
    color: #fff;
    font-size: 36px;
    font-weight: 600;
}
.bonus p{
    color: #fff;
    font-size: 16px;
    font-weight: 400;
}
.bonus{
    width: 75%;
}
.Clippathgroup {
        width: 25%;
}
.Clippathgroup {
    position: absolute;
    right: 9%;
    z-index:999;
    top:50px;
}
.relative{
    position: relative;
}
.two_phone{
    width: 50%;
    z-index: 199;
    position: sticky;
    left: 28%;
    z-index:9;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -30px auto;
    object-fit: cover;
    object-position: center;
}
.funk{
    display: flex;  
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 100px;
}
.funk h1{
    font-size: 36px;
    width: 50%;
    font-weight: 600;
    color: #141416;
}
.funk p{
    font-size: 18px;
    font-weight: 400;
    align-items: flex-end;
    display: flex;
    color: #141416;
}

.monile{
    width: 26%;
}
.phones{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 100px;
    object-fit: cover;
    object-position: center;
}

.applecation {
    background-color: #E5E5E5;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 32px;
    padding: 40px;
    position: absolute;
    top: 75%;
    z-index: 999;
    transition: all 0.5s ease-in-out; 
}

.applecation:hover {
    background-color: #0C9BE680;
}

.applecation:hover,
.applecation:hover h1,
.applecation:hover p {
    transition: all 0.5s ease-in-out; 
    cursor: pointer; 
    color: #fff;
}
.applecation img{
    width: 24%;
}
.applecation h1{
    font-weight: 600;
    color: #141416;
    font-size: 24px;
}
.applecation p{
    font-weight: 400;
    color: #141416;
    font-size: 16px;
    margin-top: 12px;
}
.pro{
    width: 50%;
}

#footer{
    padding: 60px;
    margin-top: 320px;
    background-color: #117BE2;
}
.logo_footer{
    width: 30%;
    display: flex;
    justify-content: center;
    margin: auto;
}
.instagram{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 25px;
}
.Advantages p{
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
}
.Advantages{
    display: flex;
    gap: 24px;
}
.IoLogoYoutube{
    display: flex;
    gap: 24px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yDAA+C;EAC/C,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;IACI,aAAa;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,2BAA2B;AAC7B;;;AAGA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,YAAY;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,QAAQ;IACR,YAAY;AAChB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;;IAEf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,qBAAqB;AACzB;;;AAGA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;;AAGA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;QACQ,UAAU;AAClB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,QAAQ;AACZ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;IAGI,gCAAgC;IAChC,eAAe;IACf,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,aAAa;IACb,SAAS;AACb","sourcesContent":[".logo_header {\n  width: 230px;\n  object-fit: cover;\n  object-position: center;\n  margin: auto;\n  justify-content: center;\n  display: flex;\n}\n.phone16pro {\n  width: 38%;\n  object-fit: cover;\n  object-position: center;\n}\n.payment-methods{\n  display: flex;\n}\n.section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 70px;\n  padding-bottom: 70px;\n}\n\n.product h1 {\n  font-size: 64px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.product p {\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: 30px;\n  color: #fff;\n}\n#sections {\n  background-image: url(\"./../image/section.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  margin-bottom: 100px;\n}\n\n.mobile {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.mobile img {\n  cursor: pointer;\n  width: 100px;\n  height: 30px;\n  object-fit: contain;\n  object-position: center;\n}\n.none{\n    display: none;\n}\n.about h2 {\n  color: #000;\n  font-size: 36px;\n  font-weight: 600;\n}\n.about h2 span {\n  color: #117be2;\n  font-size: 36px;\n  font-weight: 600;\n}\n.about p {\n  color: #504f4c;\n  font-size: 24px;\n  font-weight: 400px;\n}\n.about {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.features_grid {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.feature_card {\n  margin-top: 40px;\n  background: #03d5ed80;\n  padding: 20px;\n  border-radius: 32px;\n  width: 24%;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n.feature_card {\n  opacity: 0;\n  transform: translateY(30px);\n}\n\n\n.cars {\n  background-color: #117de280;\n}\n.feature_card h3 {\n  margin-top: 12px;\n  margin-bottom: 12px;\n  color: #141416;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.feature_card p {\n  font-size: 16px;\n  font-weight: 400;\n  color: #070707;\n}\n\n.icon {\n  width: 50px;\n  height: 50px;\n  background-color: #fff;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.icon img {\n  width: 25px;\n  height: 25px;\n  object-fit: contain;\n  object-position: center;\n}\n.about_app_container {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  background-color: #e5e5e5;\n  padding-top: 50px;\n  padding-left: 50px;\n  padding-right: 50px;\n  border-radius: 32px;\n  width: 90%;\n  margin: 100px auto;\n  overflow: hidden;\n}\n\n.about_image {\n  flex: 0 1 300px;\n  position: relative;\n}\n.about_text h2 {\n  font-size: 35px;\n  font-weight: 600;\n}\n.about_text p {\n  margin-top: 24px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #1b1c20;\n}\n.about_text {\n  width: 60%;\n}\n\n.about_image img {\n  max-width: 100%;\n  height: auto;\n  object-fit: contain;\n  position: relative;\n  object-position: center;\n  z-index: 1;\n  top: 4px;\n  left: 10px;\n  border-radius: 20px;\n}\n\n.about_image::before {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n}\n\n.food-image img {\n  width: 60%;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n}\n.food-image {\n  position: relative;\n}\n.sale {\n  background-color: #fc6262;\n  border-radius: 15px;\n  width: 50px;\n  text-align: center;\n  margin-top: -8px;\n  z-index: 99;\n  position: absolute;\n  margin-left: 10px;\n}\n.detail{\n    margin-left: 10px;\n    margin-top: 10px;\n}\n.red_food img{\n    width: 106px;\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n}\n.red_foods img{\n    width: 106px;\n    border-top-left-radius: 15px;\n    border-top-right-radius: 15px;\n}\n.red_food{\n    width: 107px;\n    border-radius:10px;\n    background-color: #F9FAFB;\n    box-shadow: 0px 24px 48px -12px #1018282E;\n    position: absolute;\n    left: -33%;\n    right: 0;\n    margin: auto;\n}\n.red_foods{\n    width: 107px;\n    border-radius:10px;\n    background-color: #F9FAFB;\n    box-shadow: 0px 24px 48px -12px #1018282E;\n    position: absolute;\n    left: 30%;\n    top: 30%;\n    right: 0;\n    margin: auto;\n}\n.sale p{\n    color: #fff;\n    font-size: 12px;\n    font-weight: 400;\n}\n.red_food h6{\n    font-size: 13px;\n    font-weight: 600;\n    color: #000;\n}\n.price{\n    font-weight: 600;\n    color: #CF2828;\n    font-size: 13px;\n}\n.prices{\n    display: flex;\n    gap: 5px;\n    margin-top: 7px;\n\n    margin-bottom: 6px;\n}\n.strikethrough {\n    color: #A0A0A0;\n    font-weight: 400;\n    font-size: 13px;\n    text-decoration: line-through;\n    text-align: center; \n    display: inline-block; \n}\n\n\n.add{\n    margin-bottom: 10px;\n    margin-top: 8px;\n}\n\n.koled{\n    background-color: #117be2;\n    padding: 40px 100px 60px;\n    border-radius: 32px;\n    margin: -50px auto;\n    position: relative;\n    z-index: 9;\n    width: 90%;\n}\n\n\n.bonus h1{\n    color: #fff;\n    font-size: 36px;\n    font-weight: 600;\n}\n.bonus p{\n    color: #fff;\n    font-size: 16px;\n    font-weight: 400;\n}\n.bonus{\n    width: 75%;\n}\n.Clippathgroup {\n        width: 25%;\n}\n.Clippathgroup {\n    position: absolute;\n    right: 9%;\n    z-index:999;\n    top:50px;\n}\n.relative{\n    position: relative;\n}\n.two_phone{\n    width: 50%;\n    z-index: 199;\n    position: sticky;\n    left: 28%;\n    z-index:9;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: -30px auto;\n    object-fit: cover;\n    object-position: center;\n}\n.funk{\n    display: flex;  \n    justify-content: space-between;\n    align-items: flex-start;\n    margin-top: 100px;\n}\n.funk h1{\n    font-size: 36px;\n    width: 50%;\n    font-weight: 600;\n    color: #141416;\n}\n.funk p{\n    font-size: 18px;\n    font-weight: 400;\n    align-items: flex-end;\n    display: flex;\n    color: #141416;\n}\n\n.monile{\n    width: 26%;\n}\n.phones{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 100px;\n    object-fit: cover;\n    object-position: center;\n}\n\n.applecation {\n    background-color: #E5E5E5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 32px;\n    padding: 40px;\n    position: absolute;\n    top: 75%;\n    z-index: 999;\n    transition: all 0.5s ease-in-out; \n}\n\n.applecation:hover {\n    background-color: #0C9BE680;\n}\n\n.applecation:hover,\n.applecation:hover h1,\n.applecation:hover p {\n    transition: all 0.5s ease-in-out; \n    cursor: pointer; \n    color: #fff;\n}\n.applecation img{\n    width: 24%;\n}\n.applecation h1{\n    font-weight: 600;\n    color: #141416;\n    font-size: 24px;\n}\n.applecation p{\n    font-weight: 400;\n    color: #141416;\n    font-size: 16px;\n    margin-top: 12px;\n}\n.pro{\n    width: 50%;\n}\n\n#footer{\n    padding: 60px;\n    margin-top: 320px;\n    background-color: #117BE2;\n}\n.logo_footer{\n    width: 30%;\n    display: flex;\n    justify-content: center;\n    margin: auto;\n}\n.instagram{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 25px;\n}\n.Advantages p{\n    color: #fff;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 500;\n}\n.Advantages{\n    display: flex;\n    gap: 24px;\n}\n.IoLogoYoutube{\n    display: flex;\n    gap: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
